import Page from '@admin/components/page'
import Payments from './payments'
import Overview from './overview'
import React from 'react'

const getTabs = ({ audits, scholarship, payments }) => ({
  items: [
    { label: 't(Overview)', component: <Overview scholarship={ scholarship }/> },
    { label: 't(Payments)', component: <Payments scholarship={ scholarship } payments={ payments }/> }
  ]
})

const getTasks = ({ customer }) => ({
  items: []
})

const mapResourcesToPage = (props, context) => ({
  scholarship: `/api/admin/finance/scholarships/${props.params.id}`,
  payments: `/api/admin/finance/scholarships/${props.params.id}/payments`
})

const mapPropsToPage = (props, context, resources, page) => ({
  title: 't(Scholarship)',
  tabs: getTabs(resources, context),
  tasks: getTasks(resources, context)
})

export default Page(mapResourcesToPage, mapPropsToPage)
